import { Component, inject, OnDestroy, OnInit, Renderer2, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription, takeUntil, Subject } from 'rxjs';
import { AppTopbar } from './topbar/app.topbar';
import { AppSidebar } from './app.sidebar';
import { AppFooter } from './app.footer';
import { LayoutService } from '../service/layout.service';
import { SystemStatusService } from '@/app/core/service/system-status.service';
@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [CommonModule, AppTopbar, AppSidebar, RouterModule, AppFooter],
    template: `<div class="layout-wrapper" [ngClass]="containerClass">
        <app-topbar></app-topbar>

        <app-sidebar></app-sidebar>
        <div class="layout-main-container">
            <div class="layout-main">
                <router-outlet></router-outlet>
            </div>
        </div>
        <app-footer *ngIf="showFooter"></app-footer>
        <div class="layout-mask animate-fadein"></div>

        <!-- OVERLAY GLOBAL DE PRE-AVISO (aparece cada 5 min, auto-cierre en 10s) -->
        <div class="mnt-overlay" *ngIf="showPreNoticeOverlay" (click)="dismissPreNotice()">
            <div class="mnt-dialog" (click)="$event.stopPropagation()">
                <div class="mnt-glow"></div>
                <div class="mnt-icon-wrap">
                    <span class="pi pi-clock mnt-icon"></span>
                </div>
                <div class="mnt-badge">AVISO DE MANTENIMIENTO</div>
                <h2 class="mnt-title">Próximo mantenimiento programado</h2>
                <p class="mnt-desc">{{ preNoticeMessage }}</p>
                <p class="mnt-contact">
                    <span class="pi pi-info-circle"></span>
                    Guardá tu trabajo antes de que comience el mantenimiento.
                </p>
                <div class="mnt-footer">
                    <div class="mnt-countdown">
                        <svg viewBox="0 0 36 36" class="mnt-ring">
                            <circle class="mnt-ring-bg" cx="18" cy="18" r="15"/>
                            <circle class="mnt-ring-fg" cx="18" cy="18" r="15"
                                [style.stroke-dashoffset]="94.2 - (94.2 * preNoticeCountdown / 10)"/>
                        </svg>
                        <span class="mnt-secs">{{ preNoticeCountdown }}</span>
                    </div>
                    <button type="button" class="mnt-close-btn" (click)="dismissPreNotice()">
                        <span class="pi pi-check"></span> Entendido
                    </button>
                </div>
            </div>
        </div>
    </div>`,
    styles: [`
        .mnt-overlay {
            position: fixed; inset: 0; z-index: 9999;
            background: rgba(2, 6, 23, 0.75);
            backdrop-filter: blur(6px);
            display: flex; align-items: center; justify-content: center;
            animation: mnt-fade-in .3s ease;
        }
        .mnt-dialog {
            position: relative; overflow: hidden;
            width: min(520px, 92vw);
            background: linear-gradient(145deg, #0f172a 0%, #1e293b 60%, #0f1d32 100%);
            border: 1px solid rgba(251, 191, 36, .25);
            border-radius: 24px;
            padding: 2.8rem 2.4rem 2.2rem;
            box-shadow: 0 32px 80px rgba(0,0,0,.6), 0 0 0 1px rgba(251,191,36,.08);
            display: flex; flex-direction: column; align-items: center; gap: 1rem;
            text-align: center;
            animation: mnt-slide-up .35s cubic-bezier(.22,1,.36,1);
        }
        .mnt-glow {
            position: absolute; top: -80px; left: 50%; transform: translateX(-50%);
            width: 320px; height: 200px;
            background: radial-gradient(ellipse at center, rgba(251,191,36,.18) 0%, transparent 70%);
            pointer-events: none;
        }
        .mnt-icon-wrap {
            width: 72px; height: 72px; border-radius: 20px;
            background: linear-gradient(135deg, #fef08a22, #fbbf2422);
            border: 1.5px solid rgba(251,191,36,.3);
            display: flex; align-items: center; justify-content: center;
        }
        .mnt-icon { font-size: 1.9rem; color: #fbbf24; }
        .mnt-badge {
            font-size: .65rem; font-weight: 700; letter-spacing: 2px;
            color: #fbbf24; background: rgba(251,191,36,.12);
            border: 1px solid rgba(251,191,36,.25);
            padding: .25rem .75rem; border-radius: 99px;
        }
        .mnt-title { margin: 0; font-size: 1.25rem; font-weight: 700; color: #f1f5f9; }
        .mnt-desc { margin: 0; font-size: .88rem; color: #94a3b8; line-height: 1.65; }
        .mnt-contact {
            display: flex; align-items: center; justify-content: center; gap: .45rem;
            font-size: .78rem; color: #64748b;
        }
        .mnt-contact .pi { color: #475569; font-size: .8rem; }
        .mnt-footer {
            margin-top: .5rem; width: 100%;
            display: flex; align-items: center; justify-content: space-between; gap: 1rem;
        }
        .mnt-countdown { position: relative; width: 44px; height: 44px; flex-shrink: 0; }
        .mnt-ring { width: 44px; height: 44px; transform: rotate(-90deg); }
        .mnt-ring-bg { fill: none; stroke: rgba(255,255,255,.08); stroke-width: 2.5; }
        .mnt-ring-fg {
            fill: none; stroke: #fbbf24; stroke-width: 2.5;
            stroke-linecap: round; stroke-dasharray: 94.2; stroke-dashoffset: 0;
            transition: stroke-dashoffset 1s linear;
        }
        .mnt-secs {
            position: absolute; inset: 0;
            display: flex; align-items: center; justify-content: center;
            font-size: .8rem; font-weight: 700; color: #fbbf24;
        }
        .mnt-close-btn {
            flex: 1; display: flex; align-items: center; justify-content: center; gap: .5rem;
            padding: .7rem 1.4rem; border-radius: 12px; border: none; cursor: pointer;
            background: linear-gradient(135deg, #f59e0b, #d97706);
            color: #1c1100; font-size: .9rem; font-weight: 700;
            transition: opacity .15s, transform .15s;
        }
        .mnt-close-btn:hover { opacity: .9; transform: translateY(-1px); }
        @keyframes mnt-fade-in { from { opacity:0 } to { opacity:1 } }
        @keyframes mnt-slide-up { from { opacity:0; transform:translateY(32px) scale(.97) } to { opacity:1; transform:translateY(0) scale(1) } }
    `]
})
export class AppLayout implements OnInit, OnDestroy {
    private readonly systemStatus = inject(SystemStatusService);
    private readonly cdr = inject(ChangeDetectorRef);

    showPreNoticeOverlay = false;
    preNoticeCountdown = 10;
    preNoticeMessage = '';
    showFooter = true;

    private preNoticeReminderInterval?: ReturnType<typeof setInterval>;
    private preNoticeCountdownInterval?: ReturnType<typeof setInterval>;
    private readonly REMINDER_MS = 5 * 60 * 1000;
    private destroy$ = new Subject<void>();

    overlayMenuOpenSubscription: Subscription;

    ngOnInit() {
        this.updateFooterVisibility();
        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            takeUntil(this.destroy$)
        ).subscribe(() => this.updateFooterVisibility());

        this.systemStatus.preNoticeEnabled$.pipe(takeUntil(this.destroy$)).subscribe((active) => {
            if (active) {
                this.openPreNoticeOverlay();
                clearInterval(this.preNoticeReminderInterval);
                this.preNoticeReminderInterval = setInterval(() => {
                    if (this.systemStatus.maintenance?.preNotice?.enabled
                        && !this.systemStatus.maintenance?.enabled) {
                        this.openPreNoticeOverlay();
                    }
                }, this.REMINDER_MS);
            } else {
                clearInterval(this.preNoticeReminderInterval);
                this.dismissPreNotice();
            }
        });
    }

    private buildMessage(): string {
        const pre = this.systemStatus.maintenance?.preNotice;
        if (!pre) return '';
        let timeStr: string;
        if (pre.scheduledAt) {
            const diffMin = Math.max(0, Math.round((pre.scheduledAt - Date.now()) / 60_000));
            if (diffMin >= 60) {
                const h = Math.floor(diffMin / 60), m = diffMin % 60;
                timeStr = m > 0 ? `${h}h ${m}min` : `${h}h`;
            } else {
                timeStr = `${diffMin} minuto${diffMin !== 1 ? 's' : ''}`;
            }
        } else {
            timeStr = `${pre.minutes ?? 30} minutos`;
        }
        return (pre.message || 'El sistema entrará en mantenimiento en {time}.')
            .replace('{time}', timeStr);
    }

    private updateFooterVisibility(): void {
        const url = this.router.url;
        // Completar checklist ya tiene barra fija de acciones; el pie global se solapa.
        this.showFooter =
            !url.includes('/404') && !url.includes('/checklist/completar');
        this.cdr.markForCheck();
    }

    openPreNoticeOverlay(): void {
        this.preNoticeMessage = this.buildMessage();
        this.preNoticeCountdown = 10;
        this.showPreNoticeOverlay = true;
        this.cdr.markForCheck();
        clearInterval(this.preNoticeCountdownInterval);
        this.preNoticeCountdownInterval = setInterval(() => {
            this.preNoticeCountdown--;
            this.cdr.markForCheck();
            if (this.preNoticeCountdown <= 0) this.dismissPreNotice();
        }, 1000);
    }

    dismissPreNotice(): void {
        clearInterval(this.preNoticeCountdownInterval);
        this.showPreNoticeOverlay = false;
        this.cdr.markForCheck();
    }

    menuOutsideClickListener: any;

    @ViewChild(AppSidebar) appSidebar!: AppSidebar;

    @ViewChild(AppTopbar) appTopBar!: AppTopbar;

    constructor(
        public layoutService: LayoutService,
        public renderer: Renderer2,
        public router: Router
    ) {
        this.systemStatus.startPolling();
        this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
            if (!this.menuOutsideClickListener) {
                this.menuOutsideClickListener = this.renderer.listen('document', 'click', (event) => {
                    if (this.isOutsideClicked(event)) {
                        this.hideMenu();
                    }
                });
            }

            if (this.layoutService.layoutState().staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.hideMenu();
        });
    }

    isOutsideClicked(event: MouseEvent) {
        const sidebarEl = document.querySelector('.layout-sidebar');
        const hamburgerEl = document.querySelector('.sidebar-hamburger');
        const eventTarget = event.target as Node;

        return !(sidebarEl?.isSameNode(eventTarget) || sidebarEl?.contains(eventTarget) || hamburgerEl?.isSameNode(eventTarget) || hamburgerEl?.contains(eventTarget));
    }

    hideMenu() {
        this.layoutService.layoutState.update((prev) => ({ ...prev, overlayMenuActive: false, staticMenuMobileActive: false, menuHoverActive: false }));
        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
            this.menuOutsideClickListener = null;
        }
        this.unblockBodyScroll();
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    get containerClass() {
        return {
            'layout-overlay': this.layoutService.layoutConfig().menuMode === 'overlay',
            'layout-static': this.layoutService.layoutConfig().menuMode === 'static',
            'layout-static-inactive': this.layoutService.layoutState().staticMenuDesktopInactive && this.layoutService.layoutConfig().menuMode === 'static',
            'layout-overlay-active': this.layoutService.layoutState().overlayMenuActive,
            'layout-mobile-active': this.layoutService.layoutState().staticMenuMobileActive
        };
    }

    ngOnDestroy() {
        this.systemStatus.stopPolling();
        this.destroy$.next();
        this.destroy$.complete();
        clearInterval(this.preNoticeReminderInterval);
        clearInterval(this.preNoticeCountdownInterval);
        if (this.overlayMenuOpenSubscription) {
            this.overlayMenuOpenSubscription.unsubscribe();
        }
        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
        }
    }
}
